import React from 'react'
import { browserHistory } from 'react-router'
import update from 'immutability-helper';

import { owner } from '../../core/controllers/Owner';
import { payout } from '../../core/controllers/Payout';
import { modal } from '../../core/utilities/modal';
import PayableOwnersSelect from '../../helpers/Owner/PayableOwnersSelect';
import BankAccountSelect from '../../helpers/BankAccounts/BankAccountSelect';

export default class PayoutEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            payoutId : props.payoutId,
            newPayout: props.newPayout ? true : false,
            sortID: null,
            payout: {
                name: '',
                payout: 0,
                fee_charge: 0,
                owner_id: 0,
                fee_id: 0,
                bank_identifier: 0
            },
            feeDetails: null,
            ownerDetails: null
        };
    }

    componentDidMount() {
        var self = this;
        if(!this.state.newPayout) {
            // owner.getOwner(this.state.payoutId,function(response) {
            //     self.setState({
            //         owner: response.data.owner,
            //         feeDetails: response.data.fee,
            //         active: response.data.active,
            //         wasInvited: response.data.was_invited
            //     });
            // });
        }
    }

    formatAmount(value) {
        value = value.toString();
        value = value.replace(',', '');
        if(isNaN(value) || value === 0) {
            value = 0;
        } else {
            value = new Intl.NumberFormat('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
        }

        return value;
    }

    sendPayment(e) {
        if(!this.validateData()){
            return;
        }
        var request         = this.state.payout;
        const owner         = this.state.ownerDetails;
        var amount          = this.state.payout.payout;
        var cleanedAmount   = amount.toString();
        cleanedAmount       = cleanedAmount.replace(',', '');
        var feeCharge       = this.state.payout.fee_charge;
        var cleanedFee      = feeCharge.toString();
        cleanedFee          = cleanedFee.replace(',', '');
        const feeDetails    = this.state.feeDetails;
        if (feeDetails != null) {
            const percentage   = feeDetails.fee_percentage;
            const calcedAmount = feeDetails.fee_amount / 100;
            if (cleanedAmount > 0) {
                cleanedFee = cleanedFee + calcedAmount;
                if (percentage > 0) {
                    cleanedFee += (percentage / 100) * cleanedAmount
                }
            }
            feeCharge           = cleanedFee;
        }

        const totalCharge   = parseFloat(cleanedAmount) - parseFloat(cleanedFee);
        feeCharge           = this.formatAmount(cleanedFee);
        modal.showDangerModalWithOK("Are you sure?","You are about to payout <b>$" + this.formatAmount(totalCharge) + "</b> to owner " + owner.name + ".  Total fees taken out <b>$" + feeCharge + "</b>","Yes, Pay!");
		jQuery(".move-on").on('click',function() {
            payout.sendPayout(request, function(response) {
                modal.resetBackDrop();
                modal.showSuccess('Payment Sent!', 'Payouts typically take 3 to 4 business days.');
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            });
        });
    }

    handleNameChange(e){
        this.setState({
            payout: update(this.state.payout, {
                name: {$set: e.target.value}
            })
        });
    }

    handleAmountChange(e) {
        // var money = this.formatAmount(e.target.value);

        this.setState({
            payout: update(this.state.payout, {
                payout: {$set: e.target.value}
            })
        });
    }

    handleFeeChange(e) {
        // var money = this.formatAmount(e.target.value);

        this.setState({
            payout: update(this.state.payout, {
                fee_charge: {$set: e.target.value
                }}
            )
        });
    }

    handleOwnerChange(e) {
        var self = this;
        const ownerId = e.target.value;
        if (ownerId == 0) {
            this.setState({
                payout: update(this.state.payout, {
                    owner_id: {$set: ownerId
                    }}
                ),
                feeDetails: null
            });

            return;
        }

        owner.getOwner(ownerId, function(response) {
            const fee        = response.data.fee;
            var payout       = self.state.payout.payout.toString();
            payout           = payout.replace(',', '');
            var fee_charge   = self.state.payout.fee_charge.toString();
            fee_charge       = fee_charge.replace(',', '');
            if (fee != null) {
                const percentage = fee.fee_percentage;
                const amount     = fee.fee_amount / 100;

                if (payout > 0) {
                    fee_charge += amount;
                    if (percentage > 0) {
                        fee_charge += (percentage / 100) * payout
                    }
                }
                self.setState({
                    payout: update(self.state.payout, {
                        fee_id: {$set: fee.fee_id},
                    }),
                });
            }
            self.setState({
                payout: update(self.state.payout, {
                    owner_id: {$set: ownerId},
                    fee_charge: {$set: 0}
                }
                ),
                feeDetails: response.data.fee,
                ownerDetails: response.data.owner
            });
        });
    }

    handleBankChange(e) {
        this.setState({
            payout: update(this.state.payout, {
                bank_identifier: {$set: e.target.value
                }}
            )
        });
    }

    validateData() {
        const payout    = this.state.payout;
        const name      = payout.name;
        const amount    = payout.payout.toString().replace(',', '').replace('.', '');
        const fee       = payout.fee_charge.toString().replace(',', '').replace('.', '');
        const ownerid   = payout.owner_id;
        const bankId    = payout.bank_identifier;

        if(name == null || name.length == 0) {
            modal.showInfo("Enter a payout description", "warning", "top", "center");
            return false;
        } else if(amount == null || amount <= 0) {
            modal.showInfo("Enter the amount you want to send to the owner.", "warning", "top", "center");
            return false;
        } else if(isNaN(amount)) {
            modal.showInfo("Enter a valid amount you want to pay to owner.", "warning", "top", "center");
            return false;
        } else if(isNaN(fee)) {
            modal.showInfo("Enter a valid fee amount.", "warning", "top", "center");
            return false;
        } else if(ownerid == null || ownerid == 0) {
            modal.showInfo("You need to select an owner to send this payout to.", "warning", "top", "center");
            return false;
        } else if(bankId == null || bankId == 0) {
            modal.showInfo("You need to select a bank account that you'd like funds to be sent from.", "warning", "top", "center");
            return false;
        }

        return true;
    }

    render(){
        const newPayout     = this.props.newPayout;
        const name          = this.state.payout.name;
        const bankIdentifier= this.state.payout.bank_identifier;
        const feeDetails    = this.state.feeDetails;
        var amount          = this.state.payout.payout;
        var cleanedAmount   = amount.toString();
        cleanedAmount       = cleanedAmount.replace(',', '');

        var feeCharge       = this.state.payout.fee_charge;

        var cleanedFee      = feeCharge.toString();
        cleanedFee          = cleanedFee.replace(',', '');
        cleanedFee          = parseFloat(cleanedFee);
        var disabledFee     = false;
        if (feeDetails != null) {
            const percentage   = feeDetails.fee_percentage;
            const calcedAmount = feeDetails.fee_amount / 100;
            if (cleanedAmount > 0) {
                cleanedFee = cleanedFee + calcedAmount;
                if (percentage > 0) {
                    cleanedFee += (percentage / 100) * cleanedAmount
                }
            }
            disabledFee = true;
            feeCharge           = cleanedFee;
        }

        const totalCharge   = parseFloat(cleanedAmount) - parseFloat(cleanedFee);

        const owner_id      = this.state.payout.owner_id;
        var buttonText      = 'Update Owner';
        if(newPayout) {
            if (parseFloat(totalCharge) > 0) {
                buttonText  = 'Payout $' + this.formatAmount(totalCharge) + ' to owner';
            } else {
                buttonText  = 'Payout';
            }
        }
        return (
        <div>
        <div class="row blue-bottom-margin">
            <div class="row">
                <div class="sub-page-header-row col-md-11">
                    <div class="row">
                        <span class="sub-page-header-title">Payout Owner</span>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Payout Information</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <form>
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Description</label>
                                        <input type="text" class="form-control tenant-info" name="name" placeholder="Payout description" id="name" value={name} onChange={this.handleNameChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-5 col-md-offset-1">
                                    <div class="form-group">
                                        <label>Amount</label>
                                        <input type="text" class="form-control tenant-info" name="amount" placeholder="$1,560" id="amount" value={amount} onChange={this.handleAmountChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Fee Amount</label>
                                        <input type="text" class="form-control tenant-info" disabled={disabledFee} value={feeCharge} name="fee" placeholder="$2.50" id="fee" onChange={this.handleFeeChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-5 col-md-offset-1">
                                    { feeDetails != null && (
                                        <div class="form-group">
                                            <label>Fee attached to Owner</label>
                                            <span>
                                            <p>Amount: <b>${feeDetails.fee_amount / 100}</b></p>
                                            <p>Percentage: <b>{feeDetails.fee_percentage}%</b></p>
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* {!newPayout && (
            // <div class="col-md-4 col-sm-12 col-xs-12">
            //     <div class="card">
            //         <div class="header col-md-12 col-sm-12 col-xs-12">
            //             <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-hand-action"></i></span> Action Center</h4>
            //             <p class="category"></p>
            //         </div>
            //         <div class="content">
            //             <div class="row">
            //                 <div class="col-md-12 col-sm-12 col-xs-12 action-center-item-title">
            //                     <div class="col-md-6 col-sm-5 col-xs-12">
            //                         <label>Portal</label>
            //                         {active == true ? (
            //                         <h5 class="title action-center-item-text">Activated</h5>
            //                         ) : (
            //                         <h5 class="title action-center-item-text">Not Activated</h5>
            //                         )}
            //                     </div>
            //                     <div class="col-md-6 col-sm-7 col-xs-12 action-center-button">
            //                         <button type="button" data-loading-text="Loading..." disabled={active} class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.activationEmail.bind(this)}>
            //                             Invite Owner
            //                         </button>
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // </div>
            )} */}
            <div class="col-md-4">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="header">
                                <h4 class="title"><i class="pe-7s-cash"></i> Owners</h4>
                                <p class="category">Select the owner you want to deposit funds to.  Owners who have linked their bank account will be visible here.</p>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="content">
                                        <PayableOwnersSelect columnSize={0} sortID={owner_id} title="" onChange={this.handleOwnerChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="header">
                                <h4 class="title"><i class="pe-7s-piggy"></i> Bank Account</h4>
                                <p class="category">Select a bank account you'd like to send funds from to the selected owner.</p>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="content">
                                        <BankAccountSelect columnSize={0} sortID={bankIdentifier} title="" onChange={this.handleBankChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row blue-bottom">
            <div class="blue-bottom-center-align">
                { newPayout === false ? (
                    <div>
                        {/* <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteOwnerAccount.bind(this)}>
                            Delete Owner
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.updateOwnerAccount.bind(this)}>
                            {buttonText}
                            </button>
                        </div> */}
                    </div>
                ) : (
                    <div class="col-md-12">
                        <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.sendPayment.bind(this)}>
                        {buttonText}
                        </button>
                    </div>
                )}
                <div class="clearfix"></div>
            </div>
        </div>
        </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Payout/PayoutEdit.jsx